import pythonApiClient from './pythonBaseApi';

/**
 * Servicio para gestión de tipos de entrada
 * Maneja todas las operaciones relacionadas con tipos de entrada
 */
export const tipoEntradaApi = {
  /**
   * Obtiene todos los tipos de entrada
   * @returns {Promise} - Respuesta de la API
   */
  getAll: () => {
    // Usar endpoint de Python (FastAPI)
    return pythonApiClient.get('/tipos-entradas');
  },

  /**
   * Obtiene el tipo de entrada automático (código 'A')
   * @returns {Promise} - Respuesta de la API
   */
  getAutomatico: () => {
    // Usar endpoint de Python (FastAPI)
    return pythonApiClient.get('/tipos-entradas/automatico/get');
  },

  /**
   * Obtiene un tipo de entrada específico por ID
   * @param {number} id - ID del tipo de entrada
   * @returns {Promise} - Respuesta de la API
   */
  getById: (id) => {
    // Usar endpoint de Python (FastAPI)
    return pythonApiClient.get(`/tipos-entradas/${id}`);
  },

  /**
   * Crea un nuevo tipo de entrada
   * @param {Object} data - Datos del tipo de entrada
   * @returns {Promise} - Respuesta de la API
   */
  create: (data) => {
    // Usar endpoint de Python (FastAPI)
    return pythonApiClient.post('/tipos-entradas', data);
  },

  /**
   * Actualiza un tipo de entrada existente
   * @param {number} id - ID del tipo de entrada
   * @param {Object} data - Datos actualizados del tipo de entrada
   * @returns {Promise} - Respuesta de la API
   */
  update: (id, data) => {
    // Usar endpoint de Python (FastAPI)
    return pythonApiClient.put(`/tipos-entradas/${id}`, data);
  },

  /**
   * Elimina un tipo de entrada
   * @param {number} id - ID del tipo de entrada
   * @returns {Promise} - Respuesta de la API
   */
  delete: (id) => {
    // Usar endpoint de Python (FastAPI)
    return pythonApiClient.delete(`/tipos-entradas/${id}`);
  }
};

export default tipoEntradaApi;
